define('SageDotCom/DataLayer/Events/CustomerSuccess/filterEvent',[
    'SageDotCom/DataLayer/Events/eventBase'
], function (EventBase) {

    function FilterEvent(resetting, fromResults, selected, facetName, facetType) {
        EventBase.call(this);
        if (resetting) {
            this.props = {
                'event_name': "reset_all",
                'event_category': fromResults ? "filter results" : 'filter sidebar',
                'event_action': 'filter select',
                'event_label': "Reset All",
                'event_name_level_1': "(not set)",
                'event_name_level_2': '(not set)',
                'event_name_level_3': fromResults ? "link" : "checkbox",
                'event_name_level_4': '(not set)'
            };
        } else {
            this.props = {
                'event_name': "filter_select",
                'event_category': fromResults ? "filter results" : 'filter sidebar',
                'event_action': selected ? 'filter selected' : "filter unselected",
                'event_label': facetName,
                'event_name_level_1': facetType,
                'event_name_level_2': facetName,
                'event_name_level_3': fromResults ? "clear pill" : "checkbox",
                'event_name_level_4': selected ? 'selected' : "unselected"
            };
        }
    }

    FilterEvent.prototype = Object.create(EventBase.prototype);
    
    return FilterEvent;
});
